module.exports = __webpack_public_path__ + "img/Flag_of_Slovenia.5322b275.svg";